import React from "react"

export default function FormSection({ children, className, title }) {
  return (
    <div className={className}>
      <div className="container py-10 px-4">
        <h3 className="text-tertiary mb-4">{title}</h3>
        {children}
      </div>
    </div>
  )
}
